import gql from "graphql-tag";

const CONFIRM_ROSTER_MUTATION = gql` 
  mutation ConfirmRoster ($chapterId: String!) {
    confirmRoster(chapterId: $chapterId)
    {
      success
      message
      showPrompt
    }
  }
`;
export default CONFIRM_ROSTER_MUTATION;